import { Stack, Typography } from '@rossum/ui/material';
import { text } from '../../../constants';

export const NotEditableDash = () => (
  <Stack height={1} justifyContent="center">
    <Typography
      variant="body2"
      sx={{ color: 'text.disabled', cursor: 'not-allowed' }}
    >
      {text.cellNotEditable}
    </Typography>
  </Stack>
);
